module.exports = __webpack_public_path__ + "img/1.226190e6.svg";